module.exports = "/_next/static/files/403351ffedba70e831e5558cbab0139d.jpg";